import ActionTypes from "../../../constants/ActionTypes";
import { ICookieState } from "./types";

const initialState: ICookieState = {
  shouldCallLogin: false,
};

const cookieReducer = (
  state = initialState,
  action: any,
): any => {
  switch (action.type) {
  case ActionTypes.COOKIE.SET_SHOULD_CALL_LOGIN:
    const unMutedState = { ...state };
    return {
      ...unMutedState,
      shouldCallLogin: action.payload
    };
  }
  return state;
};

export default cookieReducer;
